/**
 * 𝐴 ∩ 𝐵 = { x | x ∈ 𝐴 ∧ x ∈ 𝐵 }
 */
export default function intersection(a, b) {
  return a?.constructor !== Array || b?.constructor !== Array
    ? []
    : a.filter(Set.prototype.has, new Set(b));
}
